import React from 'react';
import { Reveal } from '../Reveal';
import { Accent, SectionHeading } from './SectionHeading';
import { painPoints } from '../../data/content';

/** Section 5 — the educator's own inner voice, set as editorial quotes. */
export function PainSection() {
  const [featured, ...rest] = painPoints;
  return <section aria-labelledby="pain-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-157" data-mp="3m1fhptuyjzyp">
      <div className="mx-auto max-w-6xl" data-id="element-158" data-mp="nj9x489yy21e">
        <SectionHeading id="pain-heading" className="max-w-3xl" title={<>
              Being Great at Brows Doesn’t Mean{' '}
              <Accent data-id="element-160" data-mp="drw0c89ejgby">Preparing a Professional Training Is Easy.</Accent>
            </>} data-id="element-159" data-mp="ni8mu60s1jkq" />

        <div className="mt-12 grid gap-5 lg:grid-cols-[1fr_1.35fr]" data-id="element-161" data-mp="8tkr9zqxl9us">
          <Reveal className="h-full" data-id="element-162" data-mp="169rl5zjuw9gf">
            <Quote {...featured} large data-id="element-163" data-mp="16asx068p4zz7" />
          </Reveal>
          <ul className="grid gap-5 sm:grid-cols-2" role="list" data-id="element-164" data-mp="11ijal06sii1o">
            {rest.map((pain, index) => <li key={pain.text} data-id="element-165" data-mp="3beanvy6av843" data-mpi={index}>
                <Reveal delay={index * 0.05} className="h-full" data-id="element-166" data-mp="3bfccl5g8nt4a">
                  <Quote {...pain} data-id="element-167" data-mp="3gbav4cevygws" />
                </Reveal>
              </li>)}
          </ul>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-168" data-mp="31mwrw0dk4qfp">
          If any of these sound familiar, <Accent data-id="element-169" data-mp="2slyo9j716kxn">Brow Instructor Ready™ was created for you.</Accent>
        </p>
      </div>
    </section>;
}
function Quote({
  text,
  tag,
  tint,
  large = false
}: {
  text: string;
  tag: string;
  tint: string;
  large?: boolean;
}) {
  return <figure className={`relative flex h-full flex-col overflow-hidden rounded-[24px] border border-brand-charcoal/8 bg-white shadow-[0_30px_60px_-44px_rgba(90,70,40,0.55)] ${large ? 'px-8 pb-8 pt-9 sm:px-10 lg:justify-between' : 'px-7 pb-6 pt-7'}`} data-id="element-170" data-mp="2iqoj4mlc5xfn">
      <span aria-hidden="true" className="absolute inset-y-0 left-0 w-1.5" style={{
      backgroundColor: tint
    }} data-id="element-171" data-mp="lvs8zal2p25n" />
      <span aria-hidden="true" className={`flex items-center justify-center rounded-full font-display font-bold leading-none text-brand-charcoal/70 ${large ? 'h-14 w-14 text-[3rem]' : 'h-10 w-10 text-[2.2rem]'}`} style={{
      backgroundColor: tint
    }} data-id="element-172" data-mp="kd1xg0fg1cmh">
        <span className="translate-y-[0.18em]" data-id="element-173" data-mp="5jyqso3e4jaj">“</span>
      </span>
      <blockquote className={`mt-5 font-display font-semibold italic leading-[1.25] text-brand-charcoal ${large ? 'text-[1.9rem] sm:text-[2.3rem]' : 'text-[1.35rem] sm:text-[1.45rem]'}`} data-id="element-174" data-mp="134l20bp48yqm">
        {text}
      </blockquote>
      <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-175" data-mp="ogq5ek7zma89">
        <span aria-hidden="true" className="h-px w-6 bg-brand-gold/60" data-id="element-176" data-mp="oggg6yuro73m" />
        <span className="font-body text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-177" data-mp="1lwvy9mp9lyfr">
          {tag}
        </span>
      </figcaption>
    </figure>;
}